export default __webpack_public_path__ + "static/media/ClarificationNeeded.6bbe4674.svg";